import { all, fork, put, takeEvery, call } from "redux-saga/effects";
import { SagaIterator } from "@redux-saga/core";

// apicore
import { APICore, setAuthorization } from "../../helpers/api/apiCore";

// helpers
import {
  login as loginApi,
  loginOTP as MobileloginApi,
  loginDetails as loginDetailsApi,
  logout as logoutApi,
  signup as signupApi,
  forgotPassword as forgotPasswordApi,
} from "../../helpers/";

import config from "../../config";

// actions
import { authApiResponseSuccess, authApiResponseError } from "./actions";

// constants
import { AuthActionTypes } from "./constants";

interface UserData {
  payload: {
    username: string;
    password: string;
    fullname: string;
    flow: string;
    email: string | null;
    mobileNumber: string | null;
    otp: string;
    IsFromOutSide: boolean;
  };
  type: string;
}

const api = new APICore();

/**
 * Login the user
 * @param {*} payload - username and password
 */
function* login({
  payload: { email, password },
  type,
}: UserData): SagaIterator {
  try {
    const response = yield call(loginApi, { email, password });
    const user = response.data;
    // NOTE - You can change this according to response format from your api
    api.setLoggedInUser(user);
    setAuthorization(user["token"]);
    yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
  } catch (error: any) {
    yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
    api.setLoggedInUser(null);
    setAuthorization(null);
  }
}

// /**
//  * Login the user
//  * @param {*} payload - mobileNumber and otp
//  */
// function* loginOTP({
//   payload: { mobileNumber, otp },
//   type,
// }: UserData): SagaIterator {
//   try {
//     const response = yield call(MobileloginApi, { mobileNumber, otp });
//     const user = response.data;
//     // NOTE - You can change this according to response format from your api
//     api.setLoggedInUser(user);
//     setAuthorization(user["token"]);
//     yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, user));
//   } catch (error: any) {
//     yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error));
//     api.setLoggedInUser(null);
//     setAuthorization(null);
//   }
// }


/**
 * Login the user with details
 * @param {*} payload - details
 */
function* loginDetails({
  payload: { details },
  type,
}: any): SagaIterator {
  try {

    api.setLoggedInUser(null);
    setAuthorization(null);
    api.clearStorage();
    // console.log("loginDetails", details);
    if (details && typeof details === 'object' && !Array.isArray(details) && Object.keys(details).length > 0) {
      api.setLoggedInUser(details);
      // setAuthorization(responseData.result.authToken);

      let authToken = details?.authToken || null;
      let mobileNo = details?.mobileNo || null;
      let emailId = details?.emailID || null;
      let channelID = details?.channelID || null;
      let is_from_outside = details?.isFromOutSide ?? 0;
      if (authToken) {
        setAuthorization(authToken);
      }
      if (mobileNo) {
        api.setDataInStorage("mobileNumber", mobileNo);
      }
      if (emailId) {
        api.setDataInStorage("email", emailId);
      }
      if (channelID) {
        api.setDataInStorage("channelID", channelID);
        api.setDataInStorage("monetisationTypeID", -100);
        api.setDataInStorage("reveneuePlanID", -100);
      }
      
      api.setDataInStorage("isFromOutside", is_from_outside);
      
      yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, details));
    } else {
      yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, "Either not an object or it's empty"));
      api.setLoggedInUser(null);
      setAuthorization(null);
    }
    
  } catch (error: any) {
    yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error.message));
    api.setLoggedInUser(null);
    setAuthorization(null);
  }
}

/**
 * Login the user with mobileNumber and otp
 * @param {*} payload - mobileNumber and otp
 */
function* loginOTP({
  payload: { flow, mobileNumber, email, otp, IsFromOutSide },
  type,
}: UserData): SagaIterator {
  try {

    if (!flow) {
      throw new Error("Parameter missing");
    }
  
    let loginId = null;
    let loginType = null;
    let countryCode = 0;
    let IsOutSide = 0;
    if (flow === "number" && mobileNumber) {
      if (!/^\d{10}$/.test(mobileNumber)) {
        throw new Error("Invalid mobile number. Must be exactly 10 digits.");
      }
      loginType = "MobileNo";
      loginId = mobileNumber;
      countryCode = 91;
      IsOutSide = 0;
    } else if (flow === "email" && email) {
      if (!/^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/.test(email)) {
        throw new Error("Invalid email format.");
      }
      loginType = "EmailId";
      loginId = email;
      IsOutSide = IsFromOutSide ? 1 : 0;
    } else {
      throw new Error("Invalid loginType. Allowed values: 'number' or 'email'.");
    }

    const data = JSON.stringify({
      loginType: loginType,
      loginId: loginId,
      validationCode: otp,
      IsFromOutSide: IsOutSide,
      countryCode: countryCode,
    });

    const configPost = {
      method: "POST",
      headers: {
        ApiKey: "dIsH19Tv0724",
        "Content-Type": "application/json",
      },
      body: data,
    };

    const url = `${config.API_URL}/api/Auth/validateotpV2`;

    const response = yield call(fetch, url, configPost);
    if (!response.ok) {
      throw new Error(`Error: ${response.statusText}`);
    }

    const responseData = yield response.json();
    // console.log(responseData);
    if (responseData.resultStatus === "Success") {
      // api.clearStorage();

      // console.log(responseData?.result?.isFromOutSide);
      api.setLoggedInUser(responseData.result);
      // setAuthorization(responseData.result.authToken);

      let authToken = responseData?.result?.authToken || null;
      let channelID = responseData?.result?.channelID || null;
      let is_from_outside = responseData?.result?.isFromOutSide ?? 0;
      if (authToken) {
        setAuthorization(authToken);
      }
      if (channelID) {
        api.setDataInStorage("channelID", channelID);
        api.setDataInStorage("monetisationTypeID", -100);
        api.setDataInStorage("reveneuePlanID", -100);
      }
      
      api.setDataInStorage("isFromOutside", is_from_outside);
      
      yield put(authApiResponseSuccess(AuthActionTypes.LOGIN_USER, responseData.result));
      // yield delay(500);
    } else {
      yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, responseData.resultMessage));
      api.setLoggedInUser(null);
      setAuthorization(null);
    }
  } catch (error: any) {
    yield put(authApiResponseError(AuthActionTypes.LOGIN_USER, error.message));
    api.setLoggedInUser(null);
    setAuthorization(null);
  }
}

/**
 * Logout the user
 */
function* logout(): SagaIterator {
  try {
    yield call(logoutApi);
    api.setLoggedInUser(null);
    setAuthorization(null);
    api.clearStorage();
    yield put(authApiResponseSuccess(AuthActionTypes.LOGOUT_USER, {}));
  } catch (error: any) {
    yield put(authApiResponseError(AuthActionTypes.LOGOUT_USER, error));
  }
}

function* signup({
  payload: { fullname, email, password },
}: UserData): SagaIterator {
  try {
    const response = yield call(signupApi, { fullname, email, password });
    const user = response.data;
    // api.setLoggedInUser(user);
    // setAuthorization(user['token']);
    yield put(authApiResponseSuccess(AuthActionTypes.SIGNUP_USER, user));
  } catch (error: any) {
    yield put(authApiResponseError(AuthActionTypes.SIGNUP_USER, error));
    api.setLoggedInUser(null);
    setAuthorization(null);
  }
}

function* forgotPassword({ payload: { email } }: UserData): SagaIterator {
  try {
    const response = yield call(forgotPasswordApi, { email });
    yield put(
      authApiResponseSuccess(AuthActionTypes.FORGOT_PASSWORD, response.data)
    );
  } catch (error: any) {
    yield put(authApiResponseError(AuthActionTypes.FORGOT_PASSWORD, error));
  }
}
export function* watchLoginUser() {
  yield takeEvery(AuthActionTypes.LOGIN_USER, login);
}

export function* watchMobileLoginUser() {
  yield takeEvery(AuthActionTypes.LOGIN_USER, loginOTP);
}
export function* watchLoginDetails() {
  yield takeEvery(AuthActionTypes.LOGIN_USER, loginDetails);
}

export function* watchLogout() {
  yield takeEvery(AuthActionTypes.LOGOUT_USER, logout);
}

export function* watchSignup(): any {
  yield takeEvery(AuthActionTypes.SIGNUP_USER, signup);
}

export function* watchForgotPassword(): any {
  yield takeEvery(AuthActionTypes.FORGOT_PASSWORD, forgotPassword);
}

function* authSaga() {
  yield all([
    // fork(watchLoginUser),
    // fork(watchMobileLoginUser),
    fork(watchLoginDetails),
    fork(watchLogout),
    fork(watchSignup),
    fork(watchForgotPassword),
  ]);
}

export default authSaga;
